import React from 'react'

// Full-viewport header, matching the home page hero and the Be Aware page.
//
// The photograph is black and white as shot and is not tinted. Legibility
// comes from a neutral black gradient at the top and bottom plus a soft band
// behind the title, all in CSS, so the image file stays reusable.
//
// The chevron is the same mark used at the foot of the Be Aware title.
// `portrait` is optional. A very wide photograph cannot be cropped to a phone
// screen without losing the subject, so a second file is used there.
// `tone: 'light'` is for a photograph too bright to darken. The veil comes off
// entirely and the type is set in blue, so the picture keeps its own light.
const PageHeader = ({ image, portrait, focus, alt, title, subtitle, tone }) => (
  <header
    className={`page-hero ${tone === 'light' ? 'page-hero--light' : ''}`}
    data-tone={tone === 'light' ? 'light' : 'dark'}
    role='img'
    aria-label={alt}
    style={{
      backgroundImage: `url(${image})`,
      backgroundPosition: focus,
      '--hero-portrait': portrait ? `url(${portrait})` : undefined,
    }}
  >
    <div className='page-hero-veil' aria-hidden='true' />
    <div className='page-hero-inner'>
      <h1 className='page-hero-title'>{title}</h1>
      {subtitle && <p className='page-hero-subtitle'>{subtitle}</p>}
    </div>
    <svg className='page-hero-chevron' viewBox='0 0 40 20' aria-hidden='true'>
      <polyline points='2,2 20,18 38,2' fill='none' stroke='currentColor' strokeWidth='2' />
    </svg>
  </header>
)

export default PageHeader
